import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils/index.ts';
import { formatCNPJ } from '../../utils/cnpjHelpers.js';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table.jsx";
import { Badge } from "../ui/badge.jsx";
import { Skeleton } from "../ui/skeleton.jsx";
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

function formatDateSafely(date, formatStr = "dd/MM/yyyy") {
  if (!date) return 'Data não disponível';
  try {
    const d = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(d.getTime())) return 'Data inválida';
    return format(d, formatStr);
  } catch {
    return 'Data inválida';
  }
}

export default function ClientList({ clients, isLoading, stats = {} }) {
  const activeClients = clients
    .filter(client => client.status === 'active')
    .slice(0, 5);

  if (isLoading) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Razão Social</TableHead>
          <TableHead>CNPJ</TableHead>
          <TableHead>Telefone</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Chamados</TableHead>
          <TableHead>Usuários</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {activeClients.map((client) => (
          <TableRow key={client.id}>
            <TableCell>
              <Link 
                to={createPageUrl(`ViewClient?id=${client.id}`)}
                className="text-blue-600 hover:underline"
              >
                {client.corporate_name || client.name}
              </Link>
            </TableCell>
            <TableCell>{formatCNPJ(client.cnpj)}</TableCell>
            <TableCell>{client.phone}</TableCell>
            <TableCell>
              <Badge variant="outline" className={
                (client.status || 'active') === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
              }>
                {(client.status || 'active') === 'active' ? 'Ativo' : 'Inativo'}
              </Badge>
            </TableCell>
            <TableCell>{stats[client.id]?.tickets ?? '-'}</TableCell>
            <TableCell>{stats[client.id]?.users ?? '-'}</TableCell>
            <TableCell>
              <Link to={createPageUrl(`ViewClient?id=${client.id}`)}>
                <Badge variant="secondary">Detalhes</Badge>
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}